import React from 'react';
import { CTAButton } from './CTAButton';
const metrics = [{
  value: '6',
  label: 'Tomos Clínicos'
}, {
  value: '4',
  label: 'Bonos Profesionales'
}, {
  value: '460+',
  label: 'Páginas de Contenido'
}, {
  value: '🌎',
  label: 'Países LATAM'
}];
export function Hero() {
  return <section className="w-full bg-off-white px-5 pb-12 pt-10 sm:pb-20 sm:pt-16" data-id="element-104" data-mp="4lywsqa2emfr">
      <div className="mx-auto flex max-w-3xl flex-col items-center text-center" data-id="element-105" data-mp="4jvyliyrdmzy">
        <span className="mb-6 inline-block rounded-full border border-sage bg-sage/15 px-4 py-1.5 text-[11px] font-semibold uppercase tracking-wider text-dark-green" data-id="element-106" data-mp="127eereur1rdz">
          🌿 Sistema Digital Premium para Nutricionistas · LATAM 2026
        </span>

        <h1 className="font-serif-display text-[24px] font-bold leading-tight text-slate sm:text-5xl md:text-6xl" data-id="element-107" data-mp="nczrv382dxu1">
          Pasá de horas preparando consultas a tenerlas listas en solo 5 minutos.
        </h1>

        <figure className="relative mt-8 w-full max-w-[680px] sm:mt-10" data-id="element-108" data-mp="381e61pamcrzu">
          <div className="relative overflow-hidden rounded-[26px] bg-off-white shadow-[0_20px_45px_-22px_rgba(61,61,61,0.28)]" data-id="element-109" data-mp="3j7zgfm2d3yi9">
            <img src="https://cdn.magicpatterns.com/uploads/kjZYyneXKfyZm4SEEbqzvw/mockup_nutri_pro_16.9.webp" alt="Nutricionista con el Sistema Nutri-Pro Completo en su consultorio" width="1365" height="768" fetchPriority="high" loading="eager" decoding="async" sizes="(max-width: 680px) calc(100vw - 40px), 680px" className="block aspect-[16/9] w-full object-cover" data-id="element-110" data-mp="3o6aq9wsnq90h" />
            <div className="pointer-events-none absolute inset-0 rounded-[26px] ring-1 ring-inset ring-white/45" aria-hidden="true" data-id="element-111" data-mp="2qlenwia5hgd4" />
            <div className="pointer-events-none absolute inset-y-0 left-0 w-10 bg-gradient-to-r from-off-white/55 to-transparent sm:w-14" aria-hidden="true" data-id="element-112" data-mp="2vglkl6505ksj" />
            <div className="pointer-events-none absolute inset-y-0 right-0 w-10 bg-gradient-to-l from-off-white/55 to-transparent sm:w-14" aria-hidden="true" data-id="element-113" data-mp="2ljh0dbupvzed" />
          </div>
          <figcaption className="px-3 pt-3 text-center text-xs font-medium text-dark-green/80" data-id="element-114" data-mp="nb1k738w7pvw">
            El sistema completo, listo para acompañar tu próxima consulta.
          </figcaption>
        </figure>

        <p className="mt-6 max-w-xl text-[12px] text-slate/70 sm:text-base" data-id="element-115" data-mp="de6munocvvj7">
          6 Tomos clínicos + 4 Bonos profesionales. 460 páginas de contenido basado en evidencia.
          Listo para descargar hoy. Desde cualquier país de habla hispana.
        </p>

        <div className="mt-8 w-full max-w-md" data-id="element-116" data-mp="112pz1eaj0sgk">
          <CTAButton label="Obtener el acceso AHORA" data-id="element-117" data-mp="111ew1gownoqi" />
          <p className="mt-3 text-xs text-slate/60 sm:text-sm" data-id="element-118" data-mp="x1ee3m2lkvep">
            Acceso inmediato · PDF descargable · Pago único · Sin suscripción
          </p>
          <p className="mt-2 text-xs font-medium text-dark-green" data-id="element-119" data-mp="3lu9wv02xxwap">
            💱 La plataforma convierte automáticamente a tu moneda local
          </p>
        </div>

        <div className="mt-7 grid w-full grid-cols-2 overflow-hidden rounded-2xl border border-sage/30 bg-white sm:mt-9 sm:grid-cols-4" data-id="element-120" data-mp="1xacfj35u5jt8">
          {metrics.map((metric, index) => <div key={metric.label} className={`flex flex-col items-center px-4 py-5 sm:py-6 ${index % 2 !== 0 ? 'border-l border-sage/20' : ''} ${index >= 2 ? 'border-t border-sage/20' : ''} sm:border-t-0 sm:border-l sm:first:border-l-0`} data-id="element-121" data-mp="269hc43xu732r" data-mpi={index}>
              <span className="font-serif-display text-4xl font-bold text-sage" data-id="element-122" data-mp="2kxublaw4v420">{metric.value}</span>
              <span className="mt-1 text-xs font-medium text-slate sm:text-sm" data-id="element-123" data-mp="2p1jxttpc59jv">{metric.label}</span>
            </div>)}
        </div>
      </div>
    </section>;
}